export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',

	groupsGrid: 'grid grid-cols-1 gap-md xl:grid-cols-2',
	groupCard: 'overflow-hidden rounded-lg border border-subtle bg-white',
	groupTitle: 'border-b border-subtle/60 px-md py-sm text-[14px] font-semibold text-default',
	groupList: 'flex flex-col',

	row: 'flex flex-col gap-3xs border-b border-subtle/60 px-md py-sm last:border-b-0 sm:flex-row sm:items-center sm:justify-between sm:gap-sm',
	rowInfo: 'flex min-w-0 flex-col gap-3xs',
	rowLabel: 'text-[13px] font-medium leading-tight text-default',
	rowMono: 'font-mono text-[11px] leading-tight text-subtle',
	gateHint: 'text-[10px] leading-tight text-subtle',
	rowMeta: 'flex shrink-0 items-center gap-sm',
	rowCalls: 'text-[11px] tabular-nums text-subtle',

	pillOn:
		'inline-flex items-center rounded-full bg-green-50 px-2xs py-3xs text-[11px] font-medium leading-none text-green-800',
	pillOff:
		'inline-flex items-center rounded-full bg-grey-25 px-2xs py-3xs text-[11px] font-medium leading-none text-subtle',

	summary: 'text-[12px] text-subtle',
};
